import React from 'react';
import { getElementFields } from '../../forms/utils/getElementFields';
import { SmartformElementData, ValidationType } from '../../types';
import { TextField } from '../../fields/TextField';

export const StringField: React.FC<SmartformElementData> = (props) => {
  const [text] = getElementFields(props).required;
  const isMultiline = props.element?.params?.isMultilineTextField || undefined;

  return (
    <TextField
      name={text.name}
      helperText={text.helpText}
      infoText={text.infoText}
      type={text.meta?.validation?.type === ValidationType.NUMBER ? 'number' : 'text'}
      placeholder={text.hint}
      multiline={isMultiline}
      label={text.label}
      required={text.validation.required}
    />
  );
};
